<script>
import { Bar, Line } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const headers = this.headers;
    const data = this.data;

    this.renderChart(
      {
        labels: headers,
        datasets: data,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: 1,
        scales: {
          yAxes: [
            {
              stacked: false,
              ticks: {
                suggestedMin: 30,
                suggestedMax: 30,
              },
            },
          ],
        },
      }
    );
  },
};
</script>
